import React, { useState } from 'react';
import { ChevronDown, ChevronUp, HelpCircle } from 'lucide-react';

interface FAQItem {
  question: string;
  answer: string;
}

export const FAQSection = () => {
  const [openFAQ, setOpenFAQ] = useState<number | null>(null);

  const faqs: FAQItem[] = [
    {
      question: "What is A2ZCampus ThinkTech Platform?",
      answer: "A2ZCampus is India's first ThinkTech platform that provides clarity-first learning for AI, startups, and real-world skills through our proprietary tools: ClarityKit™, Startup Simulator™, and Real World Readiness™."
    },
    {
      question: "How can colleges partner with A2ZCampus for workshops?",
      answer: "Colleges can partner with us by filling out our partnership form or contacting us directly at info@a2zassist.com. We customize workshops based on your students' needs and academic focus areas."
    },
    {
      question: "What makes A2ZCampus different from other training platforms?",
      answer: "We focus on clarity-first learning with proprietary tools that bridge the gap between academic knowledge and industry requirements. Our workshops are based on real startup experiences and practical industry insights."
    },
    {
      question: "Who can join A2ZCampus workshops?",
      answer: "Our workshops are designed for engineering and technology students, particularly those looking to develop product thinking, startup mindset, and real-world readiness skills."
    },
    {
      question: "What is ClarityKit™?",
      answer: "ClarityKit™ is our proprietary tool for custom-curated sessions tailored specifically for engineering and tech students based on current industry needs and market demands."
    },
    {
      question: "How does Startup Simulator™ work?",
      answer: "Startup Simulator™ provides real product stories and interactive demos from actual industry experiences, helping students understand the startup ecosystem and product development process."
    },
    {
      question: "What topics are covered in Real World Readiness™ training?",
      answer: "Real World Readiness™ covers future-ready topics including Product Thinking, System Design, AI Tools usage, Startup Culture, and industry-specific skills that employers actually look for."
    },
    {
      question: "How can students register for upcoming workshops?",
      answer: "Students can register through our website form, join our WhatsApp community, or contact us directly. We also announce workshops through our partner colleges."
    }
  ];

  const toggleFAQ = (index: number) => {
    setOpenFAQ(openFAQ === index ? null : index);
  };

  return (
    <section className="py-4 sm:py-6 md:py-8" style={{backgroundColor: '#FAF7F2'}}>
      <div className="container mx-auto px-3 sm:px-4 md:px-6">
        <div className="max-w-4xl mx-auto">
          <div className="text-center mb-4 sm:mb-6 md:mb-8">
            <div className="inline-flex items-center px-3 sm:px-4 md:px-4 py-2 md:py-2 bg-white rounded-full shadow-lg border font-bold mb-2 sm:mb-2 md:mb-3" style={{borderColor: '#C4A052', color: '#6B4423'}}>
              <HelpCircle className="w-3 h-3 sm:w-4 sm:h-4 md:w-5 md:h-5 mr-2 md:mr-3" style={{color: '#C4A052'}} />
              Frequently Asked Questions
            </div>
            <h2 className="text-lg sm:text-xl md:text-2xl lg:text-3xl font-bold mb-2 sm:mb-3 md:mb-4 px-2" style={{color: '#2C2420'}}>
              Everything You Need to Know
            </h2>
            <p className="text-sm sm:text-base md:text-base max-w-3xl mx-auto px-3" style={{color: '#2C2420'}}>
              Get answers to common questions about A2ZCampus workshops, our proprietary learning tools, and how to get involved.
            </p>
          </div>

          <div className="space-y-3 md:space-y-4">
            {faqs.map((faq, index) => (
              <div key={index} className="bg-white rounded-2xl shadow-lg border border-gray-200 overflow-hidden">
                <button
                  onClick={() => toggleFAQ(index)}
                  className="w-full px-4 md:px-6 py-3 md:py-4 text-left flex items-center justify-between hover:bg-gray-50 transition-colors"
                >
                  <h3 className="text-sm md:text-base font-semibold pr-4" style={{color: '#2C2420'}}>
                    {faq.question}
                  </h3>
                  {openFAQ === index ? (
                    <ChevronUp className="w-4 h-4 md:w-5 md:h-5 flex-shrink-0" style={{color: '#C4A052'}} />
                  ) : (
                    <ChevronDown className="w-4 h-4 md:w-5 md:h-5 flex-shrink-0" style={{color: '#C4A052'}} />
                  )}
                </button>
                {openFAQ === index && (
                  <div className="px-4 md:px-6 pb-3 md:pb-4">
                    <p className="text-xs md:text-sm leading-relaxed" style={{color: '#2C2420'}}>
                      {faq.answer}
                    </p>
                  </div>
                )}
              </div>
            ))}
          </div>

          <div className="mt-6 md:mt-8 text-center">
            <p className="text-sm md:text-base mb-3 md:mb-4" style={{color: '#2C2420'}}>
              Still have questions? We're here to help!
            </p>
            <a
              href="mailto:info@a2zassist.com"
              className="inline-flex items-center px-4 md:px-6 py-2 md:py-3 text-white font-semibold rounded-xl hover:opacity-90 transition-all transform hover:scale-105 text-sm md:text-base"
              style={{backgroundColor: '#C4A052'}}
            >
              Contact Us
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};